/** 物料状态：协同库 production_or_material（0物料 1半成品/成品） */
export const WAREHOUSE_MATERIAL_STATUS = {
  MATERIAL: 0,
  SEMI_OR_PRODUCT: 1,
}

export const WAREHOUSE_MATERIAL_STATUS_OPTIONS = [
  {
    label: '物料',
    value: WAREHOUSE_MATERIAL_STATUS.MATERIAL,
    color: 'black',
    backGroundColor: 'rgb(220,223,230)',
  },
  {
    label: '半成品/成品',
    value: WAREHOUSE_MATERIAL_STATUS.SEMI_OR_PRODUCT,
    color: 'white',
    backGroundColor: 'rgb(103,194,58)',
  },
]

/** 业务单据类型：0 产品委外，1 工序委外 */
export const WAREHOUSE_BIZ_DOC_KIND = {
  PRODUCT: 0,
  PROCESS: 1,
}

export const WAREHOUSE_BIZ_DOC_KIND_OPTIONS = [
  {
    label: '产品委外',
    value: WAREHOUSE_BIZ_DOC_KIND.PRODUCT,
    color: 'white',
    backGroundColor: 'rgb(64,158,255)',
  },
  {
    label: '工序委外',
    value: WAREHOUSE_BIZ_DOC_KIND.PROCESS,
    color: 'white',
    backGroundColor: 'rgb(230,162,60)',
  },
]

export function getWarehouseBizDocKindLabel(bizDocKind) {
  const option = WAREHOUSE_BIZ_DOC_KIND_OPTIONS.find(
    (item) => Number(item.value) === Number(bizDocKind)
  )
  return option ? option.label : '--'
}

export function parseWarehouseSpec(item = {}) {
  const row = { ...item }
  try {
    row.materialSpecList = JSON.parse(
      row.baseSpecgroupDesc || row.baseMaterialSpecDesc || '[]'
    )
  } catch (error) {
    row.materialSpecList = []
  }
  if (!Array.isArray(row.materialSpecList)) {
    row.materialSpecList = []
  }
  row.specifications = row.materialSpecList
  if (row.outsourcingDocNumber == null) {
    row.outsourcingDocNumber =
      row.baseOutsourcingDocNumber ||
      row.processOutsourcingDocNumber ||
      row.baseProcessOutsourcingDocNumber ||
      null
  }
  if (
    row.productionOrMaterial === undefined &&
    row.statusMaterial !== undefined
  ) {
    row.productionOrMaterial = row.statusMaterial
  }
  if (row.bizDocKind === undefined || row.bizDocKind === null) {
    row.bizDocKind = WAREHOUSE_BIZ_DOC_KIND.PRODUCT
  }
  row.id = [
    row.bizDocKind,
    row.baseOutsourcingDocId,
    row.baseProcessOutsourcingDocId || '',
    row.baseMaterialId,
    row.baseSpecGroupId || row.baseSpecgroupId,
    row.batchNumber || '',
  ].join('_')
  return row
}

/** 构建 /outsourcingWarehouse/list 入参 filter */
export function buildWarehouseFilter({
  baseOutsourcingDocId,
  bizDocKind,
  searchData = {},
} = {}) {
  const searchParts = [
    searchData.searchString,
    searchData.baseMaterialNumber,
    searchData.baseMaterialName,
  ].filter((item) => item !== null && item !== undefined && item !== '')

  const filter = {
    productionOrMaterial: null,
    baseMaterialId: searchData.baseMaterialId ?? null,
    baseSpecGroupId: searchData.baseSpecGroupId ?? null,
    searchString: searchParts.join(' ').trim(),
  }

  const kind =
    bizDocKind !== null && bizDocKind !== undefined && bizDocKind !== ''
      ? bizDocKind
      : searchData.bizDocKind
  if (kind !== null && kind !== undefined && kind !== '') {
    filter.bizDocKind = Number(kind)
  }

  if (
    searchData.productionOrMaterial !== '' &&
    searchData.productionOrMaterial !== null &&
    searchData.productionOrMaterial !== undefined
  ) {
    filter.productionOrMaterial = Number(searchData.productionOrMaterial)
  }

  if (baseOutsourcingDocId) {
    filter.baseOutsourcingDocId = baseOutsourcingDocId
  }

  return filter
}

/** 构建 /outsourcingWarehouse/list 完整入参 */
export function buildWarehouseListPayload({
  baseOutsourcingDocId,
  bizDocKind,
  searchData = {},
  pageParam = { pageNum: 1, pageSize: 20 },
  orderParam = [],
} = {}) {
  return {
    outsourcingWarehouseFilter: buildWarehouseFilter({
      baseOutsourcingDocId,
      bizDocKind,
      searchData,
    }),
    pageParam: {
      pageNum: pageParam.pageNum || 1,
      pageSize: pageParam.pageSize || 20,
    },
    orderParam: Array.isArray(orderParam) ? orderParam : [],
  }
}

/** 构建 /outsourcingWarehouse/listBatchInventory 入参（无 orderParam） */
export function buildBatchInventoryListPayload({
  baseOutsourcingDocId,
  bizDocKind,
  searchData = {},
  pageParam = { pageNum: 1, pageSize: 20 },
} = {}) {
  return {
    outsourcingWarehouseFilter: buildWarehouseFilter({
      baseOutsourcingDocId,
      bizDocKind,
      searchData,
    }),
    pageParam: {
      pageNum: pageParam.pageNum || 1,
      pageSize: pageParam.pageSize || 20,
    },
  }
}

export function normalizeBatchInventoryRow(item = {}) {
  const row = { ...item }
  if (row.outsourcingDocNumber == null) {
    row.outsourcingDocNumber = row.baseOutsourcingDocNumber || null
  }
  if (row.bizDocKind === undefined || row.bizDocKind === null) {
    row.bizDocKind = WAREHOUSE_BIZ_DOC_KIND.PRODUCT
  }
  // 规格可能是 JSON 数组或纯文本
  const rawSpec = row.baseSpecgroupDesc
  if (rawSpec == null || rawSpec === '') {
    row.materialSpecList = []
    row.specText = ''
  } else {
    try {
      const parsed = JSON.parse(rawSpec)
      if (Array.isArray(parsed)) {
        row.materialSpecList = parsed
        row.specText = parsed
          .map((s) => (typeof s === 'string' ? s : s?.specValue || s?.name || ''))
          .filter(Boolean)
          .join('/')
      } else {
        row.materialSpecList = []
        row.specText = String(rawSpec)
      }
    } catch (e) {
      row.materialSpecList = []
      row.specText = String(rawSpec)
    }
  }
  row.id = [
    row.bizDocKind,
    row.baseOutsourcingDocId,
    row.baseMaterialId,
    row.baseSpecGroupId || 0,
    row.batchNumber || '',
  ].join('_')
  return row
}
